const e = {
  px: "1px",
  // 1px
  tight: "-0.02em",
  // -2%
  normal: "0em",
  // 0%
  wide: "0.02em"
  // 2%
};
export {
  e as default
};
